import { render } from "./LoadingEllipsis.vue?vue&type=template&id=15d105f1&scoped=true"
const script = {}

import "./LoadingEllipsis.vue?vue&type=style&index=0&id=15d105f1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d105f1"]])

export default __exports__